import React, {Component} from 'react'
import ClientSideCacheController from '../ClientSideCacheController'
import Cannonicalize from '../Cannonicalize'
import Analytics from '../Analytics'

class ElectionPage extends Component {
  constructor(props) {
    super(props)
    this.affiliate = props.affiliate
    this.secondsTillUpdate = 30
    this.state = {
      races: Cannonicalize.election(),
      secondsTillUpdate: this.secondsTillUpdate,
      searchTerm: ''
    }


    this.timer = null

  }

  componentWillMount() {
    if (typeof window !== 'object')
      return
    this.refreshData()
    this.timer = setInterval(() => {
      this.setState({
        secondsTillUpdate: this.state.secondsTillUpdate > 0
          ? this.state.secondsTillUpdate - 1
          : 0
      }, () => {
        if (this.state.secondsTillUpdate === 0) {
          ClientSideCacheController.clear('election')
          this.refreshData()
        }
      })
    }, 1000)
  }

  refreshData() {
    ClientSideCacheController.setAffiliate(this.props.affiliate)
    ClientSideCacheController.get('election', {affiliate: this.affiliate,debug:this.props.debug}).then((res) => {
      this.setState({races: res, secondsTillUpdate: this.secondsTillUpdate})
    })
  }

  precisionRound(number, precision) {
    var factor = Math.pow(10, precision);
    return Math.round(number * factor) / factor;
  }

  componentWillUnmount() {
    delete this.timer
  }

  render() {
    return (<div className="gnm-election-page">
      <h2 className="sr-only">Election Results</h2>
      <img className="election-banner" src="http://ftpcontent.worldnow.com/kotv/custom/elections/elections-banner.jpg" alt="Election Results Banner"/>

      <div className="input-group search">
        <label htmlFor="election-search-input" className="sr-only">Search by candidate, election, or county</label>
        <input className="form-control election-search-input" type="text" name="election-search-input" placeholder="Search by candidate, election, or county…" onChange={(e) => {
            let searchTerm = e.target.value
            this.setState({searchTerm: searchTerm})
          }}/>
        <span className="input-group-btn">
          <button className="btn btn-default" type="button">
            <i className="glyphicon glyphicon-search" ></i>
            <span className="sr-only">Search</span>
          </button>
        </span>
      </div>

      <div className="well well-sm">
        <div className="fine-print">

          <em>Results will be automatically updated in {this.state.secondsTillUpdate} seconds</em>
          <div className="timer"></div>
        </div>
      </div>

      <hr/> {
        this.state.races.filter((r) => {
          if (!this.state.searchTerm)
            return true
          let reg = new RegExp(this.state.searchTerm, 'i')

          if (r.searchableString.search(reg) > -1)
            return true

          return false
        }).map((r, i, a) => {

          let totalVotes = 0
          let voteOnPeople = false
          r.candidates.map(function(c) {
            totalVotes += c.votes
            if (c.lastName && c.firstName)
              voteOnPeople = true
          })

          return (<div className="race" key={i}>
            <h3 className="h5">
              <span className="race-name">{r.title}</span>
              <span className="race-title">{r.subheader}</span>
            </h3>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col" className="name">{
                      voteOnPeople
                        ? 'Candidate'
                        : 'Position'
                    }</th>
                  <th scope="col" className="votes">Total Votes</th>
                  <th scope="col" className="percent">Vote %</th>
                  <th scope="col" className="precincts">Precincts Reporting</th>
                </tr>
              </thead>
              <tbody>
                {
                  r.candidates.sort(function(z, y) {
                    return y.votes - z.votes
                  }).map((c, j, b) => {
                    c.winner = c.winner || false
                    if(!r.hasWinners)
                      c.winner = false

                    let percent = this.precisionRound(100 * c.votes / totalVotes, 1) || 0
                    console.log(c);

                    return (<tr style={{background: c.winner ?'#e6fae6': '#fff'}} key={j}>
                      <td className="name">
                        <span>{`${c.firstName} ${c.lastName} ` }</span>

                        <span>{
                            c.party
                              ? `(${c.party})`
                              : null
                          }</span>
                      </td>
                      <td className="votes">{c.votes}</td>
                      <td className="percent">
                        <div className="bar" style={{
                            background: `linear-gradient(to right, ${c.winner
                              ? '#0f990f'
                              : '#e5e5e5'} ${percent}%, ${c.winner
                                ? '#e6fae6'
                                : '#fff'} ${percent}%)`,
                            color: c.winner
                              ? 'white'
                              : null,
                            fontWeight: c.winner
                              ? '700'
                              : '400'
                          }}>{percent}%</div>
                      </td>
                      {
                        j === 0
                          ? <td className="precincts" rowSpan={b.length}>{r.precincts}%</td>
                          : null
                      }
                    </tr>)
                  })
                }

              </tbody>
            </table>
            <hr/>
          </div>)
        })
      }
      <div className="well well-sm">
        <p className="fine-print">
          NOTE: These are unofficial results, received from the State Election Board. Results will be updated continuously throughout the evening until all precincts have been reported. All percentages have been rounded to the nearest whole number. Results are not final until certified by individual county election boards.</p>
      </div>
    </div>)
  }
}

export default ElectionPage



// WEBPACK FOOTER //
// ./app/components/custom/ssr/ElectionPage/index.js